import React from 'react';
import { FileSearch, DollarSign, Truck } from 'lucide-react';

const AdditionalExpensesSection = ({ 
  formData, 
  handleInputChange, 
  errors 
}) => {
  // Если не включены ни экспертизы, ни прочие расходы, не отображаем секцию
  if (!formData.includeExpertFees && !formData.includeOtherExpenses) return null;

  return (
    <div className="mb-6 bg-green-50 dark:bg-green-900/20 p-4 rounded-lg border border-green-200 dark:border-green-800">
      <h3 className="text-base font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <DollarSign className="w-5 h-5 mr-2 text-green-500" />
        Дополнительные судебные расходы
      </h3>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Расходы на экспертизу */}
        {formData.includeExpertFees && (
          <div>
            <label htmlFor="expertFeeAmount" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
              <FileSearch className="w-4 h-4 mr-2 text-green-500" />
              Стоимость экспертизы
            </label>
            <input
              type="text"
              id="expertFeeAmount"
              name="expertFeeAmount"
              value={formData.expertFeeAmount}
              onChange={handleInputChange}
              className={`form-input w-full ${errors.expertFeeAmount ? 'input-error' : ''}`}
              placeholder="Введите сумму"
            />
            {errors.expertFeeAmount && (
              <p className="mt-1 text-xs text-red-500 dark:text-red-400">
                {errors.expertFeeAmount}
              </p>
            )}
            <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">
              Укажите общую стоимость судебных экспертиз
            </p>
          </div>
        )}

        {/* Прочие расходы */}
        {formData.includeOtherExpenses && (
          <div>
            <label htmlFor="otherExpensesAmount" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
              <Truck className="w-4 h-4 mr-2 text-green-500" />
              Прочие судебные расходы
            </label>
            <input
              type="text"
              id="otherExpensesAmount"
              name="otherExpensesAmount"
              value={formData.otherExpensesAmount}
              onChange={handleInputChange}
              className={`form-input w-full ${errors.otherExpensesAmount ? 'input-error' : ''}`}
              placeholder="Введите сумму"
            />
            {errors.otherExpensesAmount && (
              <p className="mt-1 text-xs text-red-500 dark:text-red-400">
                {errors.otherExpensesAmount}
              </p>
            )}
            <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">
              Например, почтовые расходы, проезд, проживание и т.д.
            </p>
          </div>
        )}
      </div>

      <div className="mt-4 p-3 bg-green-100 dark:bg-green-900/40 rounded-lg">
        <h4 className="text-sm font-medium text-green-700 dark:text-green-300 mb-2">
          Виды возмещаемых судебных расходов:
        </h4>
        <ul className="text-xs text-green-700 dark:text-green-400 list-disc pl-5 space-y-1">
          <li>Оплата услуг экспертов, специалистов и переводчиков</li>
          <li>Транспортные расходы, связанные с явкой в суд</li>
          <li>Оплата осмотра доказательств на месте</li>
          <li>Почтовые расходы, связанные с рассмотрением дела</li>
          <li>Расходы на проживание вне места жительства в связи с явкой в суд</li>
          <li>Компенсация за потерю времени</li>
          <li>Иные расходы, признанные судом необходимыми для рассмотрения дела</li>
        </ul>
      </div>
    </div>
  );
};

export default AdditionalExpensesSection;